import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IAPIState } from "shared/types";
import { useVenuePageContext } from "Venues/contexts";
import { clearActionPagination, dataMetaSelector, deleteInfoBlockItem } from "Venues/state";
import { getInfoBlockItemKey, useClearActionMetaOnUnMount } from "Venues/utils";
import { VENUE_ACTIONS } from "Venues/types";
import { DeleteInfoBlockItemModal as Component } from "shared/components";
import { DeleteInfoBlockItemBaseProps, useDeleteInfoBlockItem } from "shared/utils";

export const DeleteInfoBlockItemModal: FC<DeleteInfoBlockItemBaseProps> = ({
  deleteItem,
  handleClose,
  type,
}) => {
  const { venueId } = useVenuePageContext();
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(VENUE_ACTIONS.deleteInfoBlockItem));
  useClearActionMetaOnUnMount(VENUE_ACTIONS.deleteInfoBlockItem);

  const handleDelete = () => {
    dispatch(
      deleteInfoBlockItem({
        id: deleteItem.id,
        type,
      })
    );
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionPagination(getInfoBlockItemKey(venueId, type)));
    }
  }, [apiMeta, dispatch, venueId, type]);

  const { itemReadbleName, extraDeleteMessage } = useDeleteInfoBlockItem({
    type,
    handleClose,
    deleteItemApiStatus: apiMeta?.status,
  });

  return (
    <Component
      type={type}
      deleteItem={deleteItem}
      itemReadbleName={itemReadbleName}
      handleClose={handleClose}
      handleDelete={handleDelete}
      deleteItemApiStatus={apiMeta?.status}
      deleteItemApiError={apiMeta?.error}
      extraDeleteMessage={extraDeleteMessage}
    />
  );
};
